






































































































import { PhoneInterface, StepAccountValidation } from "@/types.d.ts";
import Field from "@/components/basic/fields/Field.vue";
import NamedButton from "@/components/basic/buttons/NamedButton.vue";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import RecaptchaButton from "@/components/basic/buttons/RecaptchaSubmitButton.vue";
import Vue from "vue";
import PhoneField from "@/components/compositeFields/PhoneField.vue";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { Action } from "@/constants/ajax";

export default Vue.extend({
  name: "account-validation",
  data() {
    return {
      isExpanded: false,
      isSmsSent: false,
      phoneChanged: false,
      sentSmsCount: 0,
      documentListener: (evt: MouseEvent) => {
        return;
      },
      phone: {
        phone: "",
        phonePrefix: "",
      } as PhoneInterface,
      formData: {
        phoneNumber: "",
        phoneNumberPrefix: "",
        phoneVerificationCode2: "",
        recaptchaToken: "",
      } as StepAccountValidation,
      TRANSLATION_KEY: "steps.ConfirmPhone",
    };
  },
  methods: {
    handleSubmitSuccess() {
      this.$data.isSmsSent = true;
      this.$data.sentSmsCount++;
    },
  },
  mounted() {
    this.documentListener = (evt: MouseEvent) => {
      const target: HTMLElement | null = evt.target as HTMLElement;

      if (this.$refs.phoneNumberInput) {
        const ref = (this.$refs.phoneNumberInput as Vue).$el;
        if (target && this.isExpanded) {
          if (
            !target.classList.contains("vue-tel-input") &&
            !target.classList.contains("vti__dropdown") &&
            !target.classList.contains("vti__input") &&
            !target.classList.contains("vti__selection")
          ) {
            ref.classList.remove("modifier-vue-tel-input");
            ref.classList.add("default-vue-tel-input");
            this.isExpanded = false;
          }

          if (target.classList.contains("vti__input")) {
            ref.classList.remove("modifier-vue-tel-input");
            ref.classList.add("default-vue-tel-input");
            this.isExpanded = false;
          }
        }
      }
    };
    document.addEventListener("click", this.documentListener);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.documentListener);
  },
  watch: {
    phoneChanged() {
      this.formData.phoneNumber = this.phone.phone;
      this.formData.phoneNumberPrefix = this.phone.phonePrefix;
    },
  },
  computed: {
    UtilityHelper() {
      return UtilityHelper;
    },
  },
  components: {
    Field,
    NamedButton,
    SubmitButton,
    PhoneField,
    RecaptchaButton,
  },
});
